import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NotificationService, OperationService } from 'src/core';
import { NotificationMessage } from '@models/notificationMessage.class';

@Component({
  selector: 'hb-termsandconditions',
  templateUrl: './termsAndConditions.component.html',
  styleUrls: ['./termsAndConditions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionsComponent implements OnInit {
  @Input() contractsToAddTerms: string[];
  @Output() onAceptedTerms: EventEmitter<any> = new EventEmitter();

  public activeButton = true;
  public processingTyC = false;

  constructor(
    private operationService: OperationService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {}

  acceptTerms() {
    if (!this.activeButton) {
      return;
    }
    this.activeButton = false;
    this.processingTyC = true;

    this.addAgreementLog();

    this.processingTyC = false;
    this.onAceptedTerms.emit();
  }

  private addAgreementLog() {
    const aggrementTypeAM = 17;
    this.operationService
      .addAgreementLog(aggrementTypeAM, this.contractsToAddTerms)
      .subscribe(
        () => {},
        (error) => {
          this.showError(error);
          this.activeButton = true;
        },
      );
  }

  private showError(notificationMessage: NotificationMessage) {
    this.notificationService.showError(notificationMessage);
  }
}
